import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { getUserColor } from "shared/lib/user/getUserColor"
import { getUserInitials } from "shared/lib/user/getUserInitials"

import { isTeamRole } from "entities/team-members/types/TeamRole"

import { TeamMemberChipProps } from "../TeamMemberChip"
import { TeamMemberChipViewProps } from "../TeamMemberChipView"

export function useTeamMemberChip({
  teamMember
}: TeamMemberChipProps): TeamMemberChipViewProps {
  const { t } = useTranslation()

  const initials = useMemo(() => {
    return getUserInitials(teamMember.user)
  }, [teamMember.user])

  const color = useMemo(() => {
    return getUserColor(teamMember.user?.id)
  }, [teamMember.user?.id])

  const role = useMemo(() => {
    return isTeamRole(teamMember.role)
      ? t(`Team.Role.${teamMember.role}`)
      : undefined
  }, [teamMember.role, t])

  return {
    initials,
    color,
    role
  }
}
